export const TABLET_SIZE = 756;